import deepFreeze from 'deep-freeze';
import { Markets } from '../types/market';

import gb from './gb';
import se from './se';
import fi from './fi';
import fr from './fr';
import no from './no';
import nz from './nz';
import dk from './dk';

const markets: Markets = {
  se,
  gb,
  fi,
  fr,
  no,
  nz,
  dk,
};

export default deepFreeze(markets);
